var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassoptionsStop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3C7.26161 3 3 7.26161 3 12.5C3 17.7384 7.26161 22 12.5 22C17.7384 22 22 17.7384 22 12.5C22 7.26161 17.7384 3 12.5 3ZM12.5 20.6429C8.0101 20.6429 4.35714 16.9902 4.35714 12.5C4.35714 8.00977 8.0101 4.35714 12.5 4.35714C16.9899 4.35714 20.6429 8.00977 20.6429 12.5C20.6429 16.9902 16.9899 20.6429 12.5 20.6429ZM15.8929 8.42857H9.10714C8.7324 8.42857 8.42857 8.73207 8.42857 9.10714V15.8929C8.42857 16.2679 8.7324 16.5714 9.10714 16.5714H15.8929C16.2676 16.5714 16.5714 16.2679 16.5714 15.8929V9.10714C16.5714 8.73207 16.2676 8.42857 15.8929 8.42857ZM15.2143 15.2143H9.78571V9.78571H15.2143V15.2143Z",
    fill: "#FDFDFD",
    stroke: "#FDFDFD",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassoptionsStop);
export default __webpack_public_path__ + "static/media/classoptions-stop.ea501457fa7244b0fde5e51082e840ee.svg";
export { ForwardRef as ReactComponent };